import React, { useRef, useCallback } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import SignaturePad from "signature_pad";
import CustomDialog from "../../common/components/CustomDialog";

export default function CreateSignatureDialog({ open, onClose, onSave }) {
  const canvasRef = useRef(null);
  const sigPadRef = useRef(null);

  const initSignaturePad = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const displayWidth = canvas.parentElement.offsetWidth || 500;
    const displayHeight = 200;

    const ratio = Math.max(window.devicePixelRatio || 1, 1);

    canvas.width = displayWidth * ratio;
    canvas.height = displayHeight * ratio;

    canvas.style.width = `${displayWidth}px`;
    canvas.style.height = `${displayHeight}px`;

    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);

    sigPadRef.current = new SignaturePad(canvas, {
      backgroundColor: "#fff",
      penColor: "#000",
    });
  }, []);

  const handleClear = () => {
    if (sigPadRef.current) sigPadRef.current.clear();
  };

  const handleSave = () => {
    if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
      const dataUrl = sigPadRef.current.toDataURL("image/png");
      onSave(dataUrl);
    }
  };

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionProps={{
        onEntered: initSignaturePad,
      }}
    >
      <DialogTitle>Create Digital Signature</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: 2,
            overflow: "hidden",
            width: "100%",
            height: 200,
            mt: 3,
          }}
        >
          <canvas
            ref={canvasRef}
            style={{ width: "100%", height: "100%", cursor: "crosshair" }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClear}>Clear</Button>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}
